import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-responsive-modal';
import lodash from 'lodash';
import CommunityImg from '../../../Common/CommunityImg/CommunityImg';
import 'react-responsive-modal/styles.css';
import './EcoAllianceBlogModal.scss';


const EcoAllianceBlogModal = ({
  isOpen,
  onClose,
  blog,
  blogList
}) => {
  const openBlog = (slug) => window.open(`https://www.noissue.co/blog/${slug}`, '_blank', 'noopener');
  const [open, setOpen] = useState(isOpen);
  const [shownBlog, setShownBlog] = useState({});
  const modalContainerRef = useRef(null);
  const [column1, column2, column3] = lodash.chunk(blogList, 6);

  useEffect(() => {
    document.body.parentElement.style.overflow = 'hidden';
    return () => {
      document.body.parentElement.style.overflow = 'auto';
    }
  }, []);

  useEffect(() => {
    if (blog) setShownBlog(blog);
  }, [blog]);

  const onCloseModal = () => {
    onClose();
    setOpen(false);
  }

  const openNewBlog = tempBlog => {
    modalContainerRef.current.scrollIntoView({behavior: "smooth"});
    setShownBlog(tempBlog)
  }

  return (
    <Modal open={open} onClose={onCloseModal} classNames={{root : "eco-alliance-reel-modal"}} >
      <div  ref={modalContainerRef}>
        <div className="eco-alliance-blog-modal-breadcrumb" role="button" tabIndex="0">
          <span className="eco-alliance-blog-modal-breadcrumb-title">The Wrap {'>'}</span>
          <span className="eco-alliance-blog-modal-breadcrumb-title">Inspo {'>'}</span>
          <span className="eco-alliance-blog-modal-breadcrumb-subtitle">{shownBlog?.node?.slug}</span>
        </div>
        <div className="eco-alliance-blog-modal-container">
          <div className="eco-alliance-blog-modal-left">
            <div className="eco-alliance-blog-modal-image">
              <CommunityImg src={shownBlog?.node?.feature_image} alt="event" />
            </div>
          </div>
          <div className="eco-alliance-blog-modal-right">
            <div className="blog-card-details">
              <div className="blog-card-details-date">
                <span className="blog-card-date-label">{shownBlog?.node?.published_at}</span>
              </div>
              <div className="blog-card-details-header">
                <span className="blog-card-details-title">{shownBlog?.node?.title}</span>
              </div>
              <div className="eco-alliance-modal-separator" />
              <div className="eco-alliance-blog-modal-description">
                <pre>
                  {shownBlog?.node?.excerpt}
                </pre>
              </div>
              <button className="read-story-btn" onClick={()=>openBlog(shownBlog?.node?.slug)}>Read Brand Story</button>
              <div className="eco-alliance-modal-separator" />

              <div className="eco-alliance-modal-tags">
                {
                  (shownBlog?.node?.tags || []).map((eventTag, idx) => {
                    return <span key={`eventtag-${idx}`}>{eventTag.slug}</span>
                  })
                }
                {/* <span>{eventTypeTag}</span> */}
              </div>
            </div>
          </div>
        </div>
        <div className="noissue__eco-alliance__reel-section__blogs eco-alliance-modal">
          <div className="column1">
            {
              column1.map((blog, idx) => {
                return <div key={`blog-${idx}`}
                  className="noissue__eco-alliance__reel-section__blogs__item">
                  <CommunityImg
                    onKeyDown={() => openNewBlog(blog)}
                    onClick={() => openNewBlog(blog)}
                    role="presentation"
                    src={blog.node.feature_image} alt={blog.node.slug} />
                  <span>
                    {blog.node.excerpt}
                  </span>
                </div>
              })
            }

          </div>
          <div className="column2">
            {
              column2.map((blog, idx) => {
                return (
                  idx === 0 ? <div key={`blog-${idx}`} className="looking-for-highlights">
                    <div className="subheading">Looking for more </div>
                    <div className="heading">Highlights?</div>
                  </div> :
                    <div key={`blog-${idx}`}
                      className="noissue__eco-alliance__reel-section__blogs__item">
                      <CommunityImg
                        onKeyDown={() => openNewBlog(blog)}
                        onClick={() => openNewBlog(blog)}
                        role="presentation"
                        src={blog.node.feature_image} alt={blog.node.slug} />
                      <span>
                        {blog.node.excerpt}
                      </span>
                    </div>)
              })
            }

          </div>
          <div className="column3">
            {
              column3.map((blog, idx) => {
                return <div key={`blog-${idx}`}
                  className="noissue__eco-alliance__reel-section__blogs__item">
                  <CommunityImg
                    onKeyDown={() => openNewBlog(blog)}
                    onClick={() => openNewBlog(blog)}
                    role="presentation"
                    src={blog.node.feature_image} alt={blog.node.slug} />
                  <span>
                    {blog.node.excerpt}
                  </span>
                </div>
              })
            }
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EcoAllianceBlogModal;